import { c as _c } from "react/compiler-runtime";
import SettingConfig from '@module/config/setting';
interface Props {
  type: 'admin' | 'police';
  message: string;
}
export default function AdminChat(props) {
  const $ = _c(17);
  const {
    type,
    message
  } = props;
  let t0;
  if ($[0] !== type) {
    t0 = type === "police" && <img src={`${SettingConfig.S3_BUCKET_URL}/img/grade/ico_live_police.png`} alt="police" className="mr-1 h-[15px] w-[15px]" crossOrigin="anonymous" />;
    $[0] = type;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== type) {
    t1 = type === "admin" && <img src={`${SettingConfig.S3_BUCKET_URL}/img/grade/ico_class_a.png`} alt="admin" className="mr-1 h-[15px] w-[15px]" crossOrigin="anonymous" />;
    $[2] = type;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const t2 = type === "admin" && "\uC6B4\uC601\uD300";
  const t3 = type === "police" && "\uD3F4\uB9AC\uC2A4";
  let t4;
  if ($[4] !== t2 || $[5] !== t3) {
    t4 = <span className="relative text-nowrap">{t2}{t3}</span>;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <span className="relative ml-1 text-[13px]">:</span>;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== t0 || $[9] !== t1 || $[10] !== t4) {
    t6 = <div className="flex"><div className="relative flex h-[22.5px] flex-row items-center justify-start pr-[10px] [&>*]:inline">{t0}{t1}{t4}{t5}</div></div>;
    $[8] = t0;
    $[9] = t1;
    $[10] = t4;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== message) {
    t7 = <p className="w-full overflow-x-hidden text-left">{message}</p>;
    $[12] = message;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t6 || $[15] !== t7) {
    t8 = <div className="relative flex flex-col whitespace-pre-wrap break-all text-cht_al_2">{t6}{t7}</div>;
    $[14] = t6;
    $[15] = t7;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  return t8;
}